
import { computed, defineComponent, ref } from 'vue'
import { useJobTitleModule } from '@/modules/job-titles'
import { JobTitlesRouteNames } from '@/router/routes-names'
import usePaginationHelper from '@/views/_shared/search-list/pagination-helper'

export default defineComponent({
    name: 'view-job-titles-list',
    setup () {
        const { getJobTitles, jobTitles } = useJobTitleModule()
        const { pagination } = usePaginationHelper('title')

        const jobTitleColumns = ([
            { name: 'id', label: 'Id', field: 'id', sortable: true, align: 'left' },
            { name: 'title', label: 'Job Title', field: 'title', sortable: true, align: 'left' }
        ])

        const filter = ref<string>('')

        const filteredJobTitles = computed(() => {
            if (filter.value === '') {
                return jobTitles.value
            }
            const regexp = new RegExp(filter.value, 'i')
            return jobTitles.value.filter(jobTitle => regexp.test(`${jobTitle.title}`))
        })

        getJobTitles()

        return {
            filteredJobTitles,
            jobTitleColumns,
            JobTitlesRouteNames,
            pagination,
            filter
        }
    }
})

